export function resolvePortalUrl(currentHref: string, explicitPortalUrl?: string): string | null {
  const fallback = explicitPortalUrl?.trim();
  if (fallback) {
    return appendEntryQuery(new URL(fallback, currentHref));
  }

  const current = new URL(currentHref);

  if (current.hostname === 'localhost' || current.hostname === '127.0.0.1') {
    const localPortal = new URL(current.origin);
    localPortal.port = '5180';
    return appendEntryQuery(localPortal);
  }

  const hostLabels = current.hostname.split('.');
  if (hostLabels[0] === 'app' && hostLabels.slice(-2).join('.') === 'connectplane.com') {
    const derivedPortal = new URL(current.origin);
    if (hostLabels.length === 3) {
      derivedPortal.hostname = 'myaccount.connectplane.com';
    } else {
      hostLabels[0] = 'myaccount';
      derivedPortal.hostname = hostLabels.join('.');
    }
    return appendEntryQuery(derivedPortal);
  }

  if (hostLabels[0] === 'dashboard') {
    if (hostLabels.length === 3 && hostLabels.slice(-2).join('.') === 'connectplane.com') {
      const publicPortal = new URL(current.origin);
      publicPortal.hostname = 'myaccount.connectplane.com';
      return appendEntryQuery(publicPortal);
    }
    hostLabels[0] = 'portal';
    const derivedPortal = new URL(current.origin);
    derivedPortal.hostname = hostLabels.join('.');
    return appendEntryQuery(derivedPortal);
  }

  return null;
}

function appendEntryQuery(url: URL): string {
  url.searchParams.set('entry', 'internal');
  return url.toString();
}
